const mocks = {
  params: {
    mje: "error-3"
  }
};
export default mocks;
